import _ from 'lodash'


import { resolvePlayableActivities } from '@/shared/level-play/activityPlayability'
import { hasIntro } from '@/shared/level-play/hasIntro'
import type { ChallengeWithUnderscores } from '@/types/journey'

import { KINDS as CHALLENGE_KINDS } from '../Challenges/config'

export interface Step {
  id: string
  kind: string
  position: number
  isInitial?: boolean
  uid?: string
  activityId?: number
  isIntro?: boolean
  hasIntro?: boolean
  isSlide?: boolean
  isFirstSlide?: boolean
  slideIndex?: number
  isLastSlide?: boolean
}

/**
 * Desafios que a execução consegue montar, e os que ela pula com motivo.
 *
 * A regra é do motor (`shared/level-play/activityPlayability`) — antes vivia
 * aqui como um `filter` por kind conhecido, duplicado no quiz e sem contagem.
 */
export const getPlayability = (challenges: ChallengeWithUnderscores[]) =>
  resolvePlayableActivities({
    activities: challenges,
    knownKinds: Object.values(CHALLENGE_KINDS)
  })

export const getSteps = (challenges: ChallengeWithUnderscores[]): Step[] => {
  const { playable: activeChallenges } = getPlayability(challenges)

  const introChallenges = activeChallenges.filter(challenge =>
    hasIntro(challenge)
  )

  let steps: Step[] = []

  steps.push({
    id: 'step-initial',
    kind: CHALLENGE_KINDS.INITIAL,
    position: 0,
    isInitial: true
  })

  steps.push(
    ...introChallenges.map(step => ({
      id: `step-${step.id}-intro`,
      uid: step.uid,
      activityId: step.id,
      kind: CHALLENGE_KINDS.INTRO,
      position: step.position,
      isIntro: true
    }))
  )

  activeChallenges.forEach(step => {
    const kind = step.kind

    if (kind === CHALLENGE_KINDS.SLIDE) {
      const slides = _.get(step, 'meta.slides', [])
      const slideSteps: Step[] = slides.map((slide, index) => ({
        id: `step-${step.id}-slide-${index + 1}`,
        uid: step.uid,
        activityId: step.id,
        kind: step.kind,
        position: step.position,
        hasIntro: hasIntro(step),
        isSlide: true,
        isFirstSlide: index === 0,
        slideIndex: index,
        isLastSlide: index === slides.length - 1
      }))

      steps.push(...slideSteps)
    } else {
      steps.push({
        id: `step-${step.id}`,
        uid: step.uid,
        activityId: step.id,
        kind: step.kind,
        position: step.position,
        hasIntro: hasIntro(step)
      })
    }
  })

  const sortedSteps = _.orderBy(
    steps,
    ['isInitial', 'position', 'activityId', 'isIntro'] as any,
    ['asc', 'asc', 'asc', 'asc']
  )

  return sortedSteps
}
